/**
 * Workspace creation cap (#753).
 *
 * A user may OWN at most OWNED_WORKSPACE_CAP non-sandbox workspaces for the
 * purpose of creation. The count is derived live from the groups list (owner
 * role, excluding the hidden guide sandbox) - the backend is the hard gate
 * (createGroup returns 403 workspace_limit_reached at the limit); this client
 * helper only drives the pre-emptive disabled state so the UI matches.
 *
 * Ownership is by owner-role membership and multi-owner is supported, so a
 * co-owned workspace counts toward each owner. Transfer/promote is NOT gated,
 * so a user can end up owning more than the cap; only creation is blocked.
 */

export const OWNED_WORKSPACE_CAP = 5;

export const countOwnedWorkspaces = (groups) =>
  (groups || []).filter(
    (g) => g.guideSandbox !== true && g.membership?.role === 'owner'
  ).length;

export const isAtWorkspaceCap = (groups) =>
  countOwnedWorkspaces(groups) >= OWNED_WORKSPACE_CAP;
